/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const PlayIcon: FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3.33331 3.32642C3.33331 2.67898 3.33331 2.35526 3.46831 2.17681C3.58591 2.02135 3.76566 1.92515 3.96025 1.91353C4.1836 1.9002 4.45296 2.07977 4.99166 2.4389L12.002 7.11248C12.4472 7.40923 12.6697 7.55761 12.7473 7.74462C12.8151 7.90813 12.8151 8.09188 12.7473 8.25538C12.6697 8.4424 12.4472 8.59077 12.002 8.88752L4.99166 13.5611C4.45296 13.9202 4.1836 14.0998 3.96025 14.0865C3.76566 14.0749 3.58591 13.9787 3.46831 13.8232C3.33331 13.6447 3.33331 13.321 3.33331 12.6736V3.32642Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
